import {SystemActionsState} from "@/store/user_management/system_actions/types";
import {Module} from "vuex";
import {RootState} from "@/store/types";
import {actions} from "@/store/user_management/system_actions/actions";
import {getters} from "@/store/user_management/system_actions/getters";
import {mutations} from "@/store/user_management/system_actions/mutations";

export const state: SystemActionsState = {
    systemActions: [],
    systemUsersAction:[],
}

export const systemActions: Module<SystemActionsState, RootState> = {
    state,
    actions,
    getters,
    mutations
}
